import { MicrositeContext } from 'context/MicrositeContext';
import { useContext, useEffect, useRef } from 'react';
import { useEnvironment } from 'services/environment';
import { FullStory, isInitialized } from '@fullstory/browser';
import { onUpdate, offUpdate, CanonicalUserProfile } from '@updater/identity';

export function Fullstory({ children }) {
  const { name: environment } = useEnvironment();
  const micrositeConfig = useContext(MicrositeContext);
  const environmentRef = useRef(environment);
  environmentRef.current = environment;
  const micrositeConfigRef = useRef(micrositeConfig);
  micrositeConfigRef.current = micrositeConfig;

  useEffect(() => {
    const listener = (profile: CanonicalUserProfile) => {
      if (!isInitialized()) return;
      const { updUuid, ...profileRest } = profile;
      FullStory('setIdentity', {
        uid: updUuid,
        properties: {
          uid: updUuid,
          application: 'provider-app',
          environment: environmentRef.current,
          source: micrositeConfigRef.current?.source,
          ...profileRest,
        },
      });
    };
    onUpdate(listener);
    return () => offUpdate(listener);
  }, []);

  return <>{children}</>;
}
